(function(angular){
	'use strict';
	
	angular
		.module('viewMarketModule', [
			'coreModule',
			'losAngelesHomePriceChartModule',
			'reitElementListingModule',
			'unemploymentComparisonChartModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);